/* eslint-disable */
import React, { Component } from 'react';
import MenuItems from './navbarItems.json';

import HelpIpocn from '@material-ui/icons/Help';
import SecurityIcon from '@material-ui/icons/Security';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import BookmarksIcon from '@material-ui/icons/Bookmarks';
import ColorLensIcon from '@material-ui/icons/ColorLens';
import AudiotrackIcon from '@material-ui/icons/Audiotrack';
import HearingIcon from '@material-ui/icons/Hearing';
import ExtensionIcon from '@material-ui/icons/Extension';
import SettingsEthernetIcon from '@material-ui/icons/SettingsEthernet';
import PhonelinkSetupIcon from '@material-ui/icons/PhonelinkSetup';
import LeakAddIcon from '@material-ui/icons/LeakAdd';
import EventIcon from '@material-ui/icons/Event';
import HomeIcon from '@material-ui/icons/Home';
import LabelIcon from '@material-ui/icons/Label';
import { Link } from 'react-router-dom';
import Aux from '../../../../hoc/Aux';
import classes from './ConfigurationScreenNavbarItem.css';


class ConfigurationScreenNavbarItem extends Component {

  render() {
    if(this.props.isFirst && this.props.isSelected){
      return(
        <div>
          <div className={classes.TitleElement}>
            <p>{this.props.groupName}</p>
          </div>
          <li className="nav-item">
            <Link to={this.props.link} className={"nav-link " + classes.aItemActive} href={this.props.link}><span>{convertIconToComponent(this.props.icon)}</span> {this.props.name}</Link>
          </li>
        </div>
      );
    }else if(this.props.isLast && this.props.isSelected) {
      return(
        <div>
          <li className="nav-item">
          <Link to={this.props.link} className={"nav-link " + classes.aItemActive} href={this.props.link}><span>{convertIconToComponent(this.props.icon)}</span> {this.props.name}</Link>
           </li>
          <hr className={classes.LineBreak} />
        </div>
      );
    }else if(this.props.isFirst && this.props.isLast) {
      return(
        <div>
           <div className={classes.TitleElement}>
            <p>{this.props.groupName}</p>
          </div>
          <li className="nav-item">
            <Link to={this.props.link} className={"nav-link " + classes.aItem} href={this.props.link}><span>{convertIconToComponent(this.props.icon)}</span> {this.props.name}</Link>
          </li>
          <hr className={classes.LineBreak} />
        </div>
      );
    }else if(this.props.isFirst) {
      return(
        <div>
          <div className={classes.TitleElement}>
            <p>{this.props.groupName}</p>
          </div>
          <li className="nav-item">
          <Link to={this.props.link} className={"nav-link " + classes.aItem} href={this.props.link}><span>{convertIconToComponent(this.props.icon)}</span> {this.props.name}</Link>
          </li>
        </div>
      );
    }else if(this.props.isLast) {
      return(
        <div>
          <li className="nav-item">
          <Link to={this.props.link} className={"nav-link " + classes.aItem} href={this.props.link}><span>{convertIconToComponent(this.props.icon)}</span> {this.props.name}</Link>
          </li>
          <hr className={classes.LineBreak} />
        </div>
      );
    }else if(this.props.isSelected) {
      return(
        <div>
          <li className="nav-item">
          <Link to={this.props.link} className={"nav-link " + classes.aItem} href={this.props.link}><span>{convertIconToComponent(this.props.icon)}</span> {this.props.name}</Link>
           </li>
        </div>
      );
    }else {
      return(
        <div>
          <li className="nav-item">
          <Link to={this.props.link} className={"nav-link " + classes.aItem} href={this.props.link}><span>{convertIconToComponent(this.props.icon)}</span> {this.props.name}</Link>
          </li>
        </div>
      );
    }
  }
}

let convertIconToComponent = (ic) => {
  switch(ic) {
    case 0: return <HomeIcon />
    case 11: return <SecurityIcon />
    case 12: return <CreditCardIcon />
    case 13: return <BookmarksIcon />
    case 5: return <HelpIpocn />
    case 21: return <LabelIcon />
    case 31: return <AudiotrackIcon />
    case 32: return <HearingIcon />
    case 33: return <ExtensionIcon />
    case 34: return <SettingsEthernetIcon />
    case 35: return <PhonelinkSetupIcon />
    case 41: return <LeakAddIcon />
    case 42: return <EventIcon />
  }
}

export default ConfigurationScreenNavbarItem;
